var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"get-demo-page"}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.isShowGetDemo)?_c('get-demo-block',{on:{"show-demo":_vm.showDemo}}):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"slide-up-fade"}},[(_vm.isShowDemo)?_c('demo-show-block',{staticClass:"demo-show-block"}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }